import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MailCheck, AlertTriangle } from "lucide-react";
import api from "@/lib/api";

const STYLE = {
  Reachable: "text-green-300 border-green-400/40 bg-green-400/10",
  "Awaiting Production DNS": "text-amber-300 border-amber-400/40 bg-amber-400/10",
  Degraded: "text-orange-300 border-orange-400/40 bg-orange-400/10",
  Misconfigured: "text-red-300 border-red-400/40 bg-red-400/10",
  Unavailable: "text-red-300 border-red-400/40 bg-red-400/10",
};

export const EmailBrandingChip = () => {
  const nav = useNavigate();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/system/email-preflight/chip").then((r) => setC(r.data)).catch(() => setC(false)); }, []);
  if (!c) return null;
  const style = c.stale ? STYLE.Degraded : (STYLE[c.state] || "text-muted-foreground border-white/20 bg-white/5");
  const tip = `Public asset: ${c.summary}\nCID fallback: ${c.cid_fallback_configured ? "Configured" : "Unavailable"}\nLast checked: ${c.last_checked ? new Date(c.last_checked).toLocaleString() : "never"}\nLast success: ${c.last_success ? new Date(c.last_success).toLocaleString() : "—"}`;
  const open = () => nav("/admin/system?section=email-brand-preflight");
  return (
    <button
      type="button"
      onClick={open}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } }}
      title={tip}
      aria-label="Open Email Brand Preflight status"
      data-testid="email-branding-chip"
      className={`status-pill border inline-flex items-center gap-1.5 whitespace-nowrap cursor-pointer transition-colors hover:brightness-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-1 focus-visible:ring-offset-background ${style}`}
    >
      <MailCheck size={12} aria-hidden="true" />
      <span>{c.display_label}</span>
      {(c.requires_attention || c.has_active_outage) && <AlertTriangle size={11} aria-hidden="true" data-testid="email-branding-chip-attention" />}
      {c.has_active_outage && <span className="text-[10px] font-semibold" data-testid="email-branding-chip-outage">· Active Issue</span>}
    </button>
  );
};
